"use client";

import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import ICoverageArea from "@/interfaces/coverage-area.interface";
import coverageAreaService from "@/services/coverage-area.service";
import { ByIdRequestProps, RequestsBaseReturn } from "@/types/requests.types";

export type Return = RequestsBaseReturn<ICoverageArea | null>;

export type Props = ByIdRequestProps;

type UseSwrGetCoverageAreaByIdParams = [string, number];

const useGetCoverageAreaById = ({ _id }: Props): Return => {
  const fetcher = useSWR<ICoverageArea, Error, UseSwrGetCoverageAreaByIdParams | null>(
    _id ? [SWR_KEYS.getCoverageAreaById, _id] : null,
    ([, coverageAreaId]) => coverageAreaService.getById(coverageAreaId),
    { revalidateOnFocus: false, shouldRetryOnError: false, errorRetryCount: 0 }
  );

  const { data = null, isValidating: isLoading, error } = fetcher;

  return { data, isLoading, error };
};

export default useGetCoverageAreaById;
